import React from "react";
import Card from "../components/Card";

const Menu = ({ ...props }) => {
  return (
    <div className="menuContainer">
      {/* <h2>Menu</h2> */}
      <div className="col">
        <div className="tabs">
          {props.menu.map((card, key) => {
            // console.log(card, key);
            return (
              <>
                <Card
                  key={key}
                  index={key}
                  name={card.name}
                  img={card.img}
                  items={card.items}
                />
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Menu;
